import { FOLLOW_UPS_BY_INTENT, ROOT_INTENTS } from "../constants/suggestions";

// Intent classification patterns
const INTENT_PATTERNS = {
  COMPARE:
    /\bcompare|vs\.?|differences|versus|group(s)? of swings|side\s*by\s*side/,
  CORRELATION: /\bcorrelat(e|ion)|relationship|report\b/,
  IMPROVEMENT: /\bimprove|improvement|fix|better|tips|areas?\s+to\s+improve/,
  SPEED: /\bspeed|faster|km\/h|mph|club\s*speed|ball\s*speed/,
  TILES: /\btile|data\s*tile|dashboard|metric|kpi/,
};

/**
 * Generate next suggestion prompts based on conversation history
 * @param {Array} messagesHistory - Array of message objects
 * @param {Object} options - Configuration options
 * @param {number} options.max - Maximum number of suggestions to return
 * @returns {Array} Array of suggestion strings
 */
export function generateNextSuggestions(
  messagesHistory = [],
  { max = 4 } = {}
) {
  const genericSuggestions = FOLLOW_UPS_BY_INTENT[ROOT_INTENTS.GENERIC] || [];

  try {
    const firstUserMessage = pickFirstUserMessage(messagesHistory);
    const detectedIntent = classifyIntent(firstUserMessage);

    const suggestionPool =
      FOLLOW_UPS_BY_INTENT[detectedIntent] || genericSuggestions;

    // Filter out suggestions user has already asked
    const filteredSuggestions = suggestionPool.filter(
      (suggestion) => !userAsked(messagesHistory, suggestion)
    );

    return filteredSuggestions.slice(0, max);
  } catch (error) {
    console.error("Error generating suggestions:", error);
    return genericSuggestions.slice(0, max);
  }
}

function classifyIntent(text = "") {
  const query = text.toLowerCase();

  if (INTENT_PATTERNS.SPEED.test(query)) return ROOT_INTENTS.SPEED;
  if (INTENT_PATTERNS.TILES.test(query)) return ROOT_INTENTS.TILES;
  if (INTENT_PATTERNS.IMPROVEMENT.test(query)) return ROOT_INTENTS.IMPROVEMENT;
  if (INTENT_PATTERNS.COMPARE.test(query)) return ROOT_INTENTS.COMPARE;
  if (INTENT_PATTERNS.CORRELATION.test(query)) return ROOT_INTENTS.CORRELATION;

  return ROOT_INTENTS.GENERIC;
}

function normalize(text = "") {
  return String(text)
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/[.\s!?]+$/g, "") // strip trailing punctuation/spaces
    .trim();
}

function pickFirstUserMessage(messagesHistory = []) {
  return (
    (messagesHistory || []).find((m) => m?.from === "user" && !m?.pending)
      ?.message || ""
  );
}

function userAsked(messagesHistory = [], text = "") {
  if (!text) return false;
  const normalizedTarget = normalize(text);

  return messagesHistory.some(
    (msg) =>
      msg?.from === "user" &&
      !msg?.pending &&
      normalize(msg?.message) === normalizedTarget
  );
}
